import { InMemoryCache } from '@apollo/client/cache';
import { relayStylePagination } from '@apollo/client/utilities';

import configurationService from '../../services/configurationService';
import createGraphqlClient from '../graphqlClient/createGraphqlClient';

/**
 * @deprecated
 * This legacy clientCacheOptions is not the way we'd like the caching in our app to work
 */
export const clientCacheOptions = {
  typePolicies: {
    Query: {
      fields: {
        hirerActivitiesByJob: relayStylePagination(),
      },
    },
  },
};

/**
 * @deprecated
 * This legacy hirerGraphqlClient does not follow our preferred pattern of coding e.g. off-standard caching patterns
 */
const hirerGraphqlClient = createGraphqlClient({
  apiUri: configurationService.getHirerGraphqlUrl(),
  apiName: 'hirer-graphql-api',
  cache: new InMemoryCache(clientCacheOptions),
  credentials: 'same-origin',
});
export default hirerGraphqlClient;
